import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_DETAIL_THUCHI,
  POST_THANHTOAN,
  DELETE_THANHTOAN,
  POST_THANHTOAN_ALL,
} from "actions/QuanLyThuChi/actionTypes";
import {
  getDetailThuChiSuccess,
  getDetailThuChiFailure,
  postThanhToanChoVaySuccess,
  postThanhToanChoVayFailure,
  deleteThanhToanChoVaySuccess,
  deleteThanhToanChoVayFailure,
} from "actions/QuanLyThuChi";
import QuanLyThuChiApi from "service/quanLyThuChiApi";
import { pushNotification } from "utils/notifications";
import { getLanDongLaiChoVay } from "actions/QuanLyChoVay";
import { showInPhieuThuChi } from "actions/InThuChi";

function* getDetailThuChi(action) {
  try {
    const response = yield call(QuanLyThuChiApi.list, action.dataSearch);
    if (response.data) {
      pushNotification("Get data success", "success", "TOP_CENTER", 1000);
      yield put(getDetailThuChiSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_CENTER", 1000);
    yield put(getDetailThuChiFailure());
  }
}
function* postThanhToan(action) {
  try {
    const response = yield call(QuanLyThuChiApi.thanhToan, action.dataPost);
    if (response.data) {

      if (response.data == "-500") {
        if (action.dataPost.isShowInKhiThanhToan) {
          yield put(showInPhieuThuChi(response.data));
        }

        yield put(postThanhToanChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
        pushNotification("Tất toán thành công. Đã thực hiện hợp đồng theo cấu hình tất toán.", "success", "TOP_CENTER", 4000);
      }
      else {
        //pushNotification("Thêm phiếu thành công", "success", "TOP_CENTER", 2000);
        if (action.dataPost.isShowInKhiThanhToan) {
          yield put(showInPhieuThuChi(response.data));
        } else {
          pushNotification("Thêm phiếu thành công", "success", "TOP_CENTER", 2000);
        }
        yield put(postThanhToanChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
      }
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 1000);
    yield put(postThanhToanChoVayFailure());
  }
}
function* postThanhToanAll(action) {
  try {
    const response = yield call(QuanLyThuChiApi.thanhToanAll, action.dataPost);
    if (response.ok) {
      if (response.data === -1) {
        pushNotification("Đã thanh toán hết tiền lãi.Vui lòng tất toán hợp đồng.", "error", "TOP_CENTER", 2000);
        yield put(postThanhToanChoVayFailure());
      }
      else if (response.data === -2) {
        pushNotification("Ngày đóng lãi phải lớn hơn ngày tạo hợp đồng.", "error", "TOP_CENTER", 2000);
        yield put(postThanhToanChoVayFailure());
      }
      else if (response.data === -3) {
        pushNotification("Ngày đóng lãi phải lớn hoặc bằng ngày đóng lãi sau cùng.", "error", "TOP_CENTER", 2000);
        yield put(postThanhToanChoVayFailure());
      }
      else if (response.data == "-500") {
        pushNotification("Tất toán thành công. Đã thực hiện hợp đồng theo cấu hình tất toán.", "success", "TOP_CENTER", 4000);
        yield put(showInPhieuThuChi(response.data));
        yield put(postThanhToanChoVaySuccess(response.data));
      }
      else {
        if (action.dataPost.isShowInKhiThanhToan) {
          yield put(showInPhieuThuChi(response.data));
        } else {
          pushNotification("Thêm phiếu thành công", "success", "TOP_CENTER", 1000);
        }
        yield put(postThanhToanChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
      }
      //pushNotification("Thêm phiếu thành công", "success", "TOP_CENTER", 1000);

    } else {
      pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 1000);
      yield put(postThanhToanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 1000);
    yield put(postThanhToanChoVayFailure());
  }
}
function* deleteThanhToan(action) {
  try {
    const response = yield call(QuanLyThuChiApi.xoaThanhToan, action.dataPost);
    if (response.data) {
      pushNotification("Xóa phiếu thành công.", "success", "TOP_CENTER", 2000);
      yield put(deleteThanhToanChoVaySuccess(response.data));
      yield put(getLanDongLaiChoVay(action.dataSearch));
    }
  } catch (error) {
    pushNotification("Xóa phiếu thất bại", "error", "TOP_CENTER", 2000);
    yield put(deleteThanhToanChoVayFailure());
  }
}
function* watchRequest() {
  yield takeLatest(POST_THANHTOAN, postThanhToan);
  yield takeLatest(POST_THANHTOAN_ALL, postThanhToanAll);
  yield takeLatest(DELETE_THANHTOAN, deleteThanhToan);
  yield takeLatest(GET_DETAIL_THUCHI, getDetailThuChi);
}

export default function* sagas() {
  yield all([watchRequest()]);
}
